import React from 'react';


const Connectrequest = props => {


  return (

        <div style={{'box-shadow': '0 0 7px rgba(0,0,0,0.5)', 'color':'#980837', 'font-size':'1.2em', 'margin-bottom':'8px', 'padding':'2px'}}>

                <b>Кратко:</b> для подключения к компьютерной сети университета наобходимо подать заявку через личный кабинет, либо оформить ее в виде  <a href='http://ocnit.tula.ru/userdocs/d1459856323.pdf' style={{'cursor':'pointer'}}>служебной записки </a> и прислать внутренней электронной почтой ( принести лично в 9-602, 9-604 )

        </div>
  )

}
export default Connectrequest
